import { render, staticRenderFns } from "./goodsChange.vue?vue&type=template&id=c3f4a5b6&scoped=true&"
import script from "./goodsChange.vue?vue&type=script&lang=js&"
export * from "./goodsChange.vue?vue&type=script&lang=js&"
import style0 from "./goodsChange.vue?vue&type=style&index=0&id=c3f4a5b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f4a5b6",
  null
  
)

export default component.exports